/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onGoalByHabitatID = /* GraphQL */ `subscription OnGoalByHabitatID($habitatID: ID!) {
  onGoalByHabitatID(habitatID: $habitatID) {
    id
    habitatID
    emoji
    title
    type
    start
    end
    allDay
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    todo
    notes
    complete
    recurrenceCompletionStates
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    completions
    completions_per_period
    period
    reference_code
    readGroups
    isTemplate
    category_ids
    color
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnGoalByHabitatIDSubscriptionVariables,
  APITypes.OnGoalByHabitatIDSubscription
>;
export const onSendNotification = /* GraphQL */ `subscription OnSendNotification($habitatID: ID!) {
  onSendNotification(habitatID: $habitatID) {
    msg
    habitatID
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnSendNotificationSubscriptionVariables,
  APITypes.OnSendNotificationSubscription
>;
export const onCreateAlarm = /* GraphQL */ `subscription OnCreateAlarm($owner: String) {
  onCreateAlarm(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    start
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    participantIDS
    checklist
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    color
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAlarmSubscriptionVariables,
  APITypes.OnCreateAlarmSubscription
>;
export const onUpdateAlarm = /* GraphQL */ `subscription OnUpdateAlarm($owner: String) {
  onUpdateAlarm(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    start
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    participantIDS
    checklist
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    color
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAlarmSubscriptionVariables,
  APITypes.OnUpdateAlarmSubscription
>;
export const onDeleteAlarm = /* GraphQL */ `subscription OnDeleteAlarm($owner: String) {
  onDeleteAlarm(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    start
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    participantIDS
    checklist
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    color
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAlarmSubscriptionVariables,
  APITypes.OnDeleteAlarmSubscription
>;
export const onCreateAlert = /* GraphQL */ `subscription OnCreateAlert($owner: String) {
  onCreateAlert(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    start
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    participantIDS
    checklist
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    goalID
    goal {
      id
      habitatID
      emoji
      title
      type
      start
      end
      allDay
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      location
      principal {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      principalID
      participantIDS
      checklist
      todo
      notes
      complete
      recurrenceCompletionStates
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      completions
      completions_per_period
      period
      reference_code
      readGroups
      isTemplate
      category_ids
      color
      owner
      createdAt
      updatedAt
      __typename
    }
    color
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAlertSubscriptionVariables,
  APITypes.OnCreateAlertSubscription
>;
export const onUpdateAlert = /* GraphQL */ `subscription OnUpdateAlert($owner: String) {
  onUpdateAlert(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    start
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    participantIDS
    checklist
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    goalID
    goal {
      id
      habitatID
      emoji
      title
      type
      start
      end
      allDay
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      location
      principal {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      principalID
      participantIDS
      checklist
      todo
      notes
      complete
      recurrenceCompletionStates
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      completions
      completions_per_period
      period
      reference_code
      readGroups
      isTemplate
      category_ids
      color
      owner
      createdAt
      updatedAt
      __typename
    }
    color
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAlertSubscriptionVariables,
  APITypes.OnUpdateAlertSubscription
>;
export const onDeleteAlert = /* GraphQL */ `subscription OnDeleteAlert($owner: String) {
  onDeleteAlert(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    start
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    participantIDS
    checklist
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    goalID
    goal {
      id
      habitatID
      emoji
      title
      type
      start
      end
      allDay
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      location
      principal {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      principalID
      participantIDS
      checklist
      todo
      notes
      complete
      recurrenceCompletionStates
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      completions
      completions_per_period
      period
      reference_code
      readGroups
      isTemplate
      category_ids
      color
      owner
      createdAt
      updatedAt
      __typename
    }
    color
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAlertSubscriptionVariables,
  APITypes.OnDeleteAlertSubscription
>;
export const onCreateEvent = /* GraphQL */ `subscription OnCreateEvent($owner: String) {
  onCreateEvent(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    start
    end
    allDay
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    todo
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    color
    tags
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateEventSubscriptionVariables,
  APITypes.OnCreateEventSubscription
>;
export const onUpdateEvent = /* GraphQL */ `subscription OnUpdateEvent($owner: String) {
  onUpdateEvent(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    start
    end
    allDay
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    todo
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    color
    tags
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateEventSubscriptionVariables,
  APITypes.OnUpdateEventSubscription
>;
export const onDeleteEvent = /* GraphQL */ `subscription OnDeleteEvent($owner: String) {
  onDeleteEvent(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    start
    end
    allDay
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    todo
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    color
    tags
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteEventSubscriptionVariables,
  APITypes.OnDeleteEventSubscription
>;
export const onCreateMeal = /* GraphQL */ `subscription OnCreateMeal($owner: String) {
  onCreateMeal(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    mealType
    start
    end
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    ingredients {
      id
      title
      checked
      shoppingListID
      __typename
    }
    prepNotes {
      id
      title
      icon
      description
      __typename
    }
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    recipes {
      items {
        id
        mealID
        recipeID
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    eaten
    recommended
    acceptedRecommended
    skipped
    meal_plan_id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMealSubscriptionVariables,
  APITypes.OnCreateMealSubscription
>;
export const onUpdateMeal = /* GraphQL */ `subscription OnUpdateMeal($owner: String) {
  onUpdateMeal(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    mealType
    start
    end
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    ingredients {
      id
      title
      checked
      shoppingListID
      __typename
    }
    prepNotes {
      id
      title
      icon
      description
      __typename
    }
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    recipes {
      items {
        id
        mealID
        recipeID
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    eaten
    recommended
    acceptedRecommended
    skipped
    meal_plan_id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMealSubscriptionVariables,
  APITypes.OnUpdateMealSubscription
>;
export const onDeleteMeal = /* GraphQL */ `subscription OnDeleteMeal($owner: String) {
  onDeleteMeal(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    mealType
    start
    end
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    ingredients {
      id
      title
      checked
      shoppingListID
      __typename
    }
    prepNotes {
      id
      title
      icon
      description
      __typename
    }
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    recipes {
      items {
        id
        mealID
        recipeID
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    eaten
    recommended
    acceptedRecommended
    skipped
    meal_plan_id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteMealSubscriptionVariables,
  APITypes.OnDeleteMealSubscription
>;
export const onCreateMealRecipe = /* GraphQL */ `subscription OnCreateMealRecipe {
  onCreateMealRecipe {
    id
    mealID
    recipeID
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMealRecipeSubscriptionVariables,
  APITypes.OnCreateMealRecipeSubscription
>;
export const onUpdateMealRecipe = /* GraphQL */ `subscription OnUpdateMealRecipe {
  onUpdateMealRecipe {
    id
    mealID
    recipeID
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMealRecipeSubscriptionVariables,
  APITypes.OnUpdateMealRecipeSubscription
>;
export const onDeleteMealRecipe = /* GraphQL */ `subscription OnDeleteMealRecipe {
  onDeleteMealRecipe {
    id
    mealID
    recipeID
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteMealRecipeSubscriptionVariables,
  APITypes.OnDeleteMealRecipeSubscription
>;
export const onCreateDashboard = /* GraphQL */ `subscription OnCreateDashboard($owner: String, $read_accounts: String) {
  onCreateDashboard(owner: $owner, read_accounts: $read_accounts) {
    id
    name
    description
    device_type
    user_id
    read_accounts
    read_groups
    full_access_groups
    layout
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDashboardSubscriptionVariables,
  APITypes.OnCreateDashboardSubscription
>;
export const onUpdateDashboard = /* GraphQL */ `subscription OnUpdateDashboard($owner: String, $read_accounts: String) {
  onUpdateDashboard(owner: $owner, read_accounts: $read_accounts) {
    id
    name
    description
    device_type
    user_id
    read_accounts
    read_groups
    full_access_groups
    layout
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDashboardSubscriptionVariables,
  APITypes.OnUpdateDashboardSubscription
>;
export const onDeleteDashboard = /* GraphQL */ `subscription OnDeleteDashboard($owner: String, $read_accounts: String) {
  onDeleteDashboard(owner: $owner, read_accounts: $read_accounts) {
    id
    name
    description
    device_type
    user_id
    read_accounts
    read_groups
    full_access_groups
    layout
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDashboardSubscriptionVariables,
  APITypes.OnDeleteDashboardSubscription
>;
export const onCreateDomain = /* GraphQL */ `subscription OnCreateDomain($owner: String!) {
  onCreateDomain(owner: $owner) {
    id
    name
    parentDomainID
    subDomains {
      items {
        id
        name
        parentDomainID
        subDomains {
          items {
            id
            name
            parentDomainID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDomainSubscriptionVariables,
  APITypes.OnCreateDomainSubscription
>;
export const onUpdateDomain = /* GraphQL */ `subscription OnUpdateDomain($owner: String!) {
  onUpdateDomain(owner: $owner) {
    id
    name
    parentDomainID
    subDomains {
      items {
        id
        name
        parentDomainID
        subDomains {
          items {
            id
            name
            parentDomainID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDomainSubscriptionVariables,
  APITypes.OnUpdateDomainSubscription
>;
export const onDeleteDomain = /* GraphQL */ `subscription OnDeleteDomain($owner: String!) {
  onDeleteDomain(owner: $owner) {
    id
    name
    parentDomainID
    subDomains {
      items {
        id
        name
        parentDomainID
        subDomains {
          items {
            id
            name
            parentDomainID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDomainSubscriptionVariables,
  APITypes.OnDeleteDomainSubscription
>;
export const onCreateFile = /* GraphQL */ `subscription OnCreateFile($owner: String, $read_accounts: String) {
  onCreateFile(owner: $owner, read_accounts: $read_accounts) {
    id
    name
    description
    file_type
    read_accounts
    read_groups
    full_access_groups
    data {
      bucket
      region
      key
      __typename
    }
    public
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateFileSubscriptionVariables,
  APITypes.OnCreateFileSubscription
>;
export const onUpdateFile = /* GraphQL */ `subscription OnUpdateFile($owner: String, $read_accounts: String) {
  onUpdateFile(owner: $owner, read_accounts: $read_accounts) {
    id
    name
    description
    file_type
    read_accounts
    read_groups
    full_access_groups
    data {
      bucket
      region
      key
      __typename
    }
    public
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateFileSubscriptionVariables,
  APITypes.OnUpdateFileSubscription
>;
export const onDeleteFile = /* GraphQL */ `subscription OnDeleteFile($owner: String, $read_accounts: String) {
  onDeleteFile(owner: $owner, read_accounts: $read_accounts) {
    id
    name
    description
    file_type
    read_accounts
    read_groups
    full_access_groups
    data {
      bucket
      region
      key
      __typename
    }
    public
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteFileSubscriptionVariables,
  APITypes.OnDeleteFileSubscription
>;
export const onCreateGoal = /* GraphQL */ `subscription OnCreateGoal($owner: String) {
  onCreateGoal(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    start
    end
    allDay
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    todo
    notes
    complete
    recurrenceCompletionStates
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    completions
    completions_per_period
    period
    reference_code
    readGroups
    isTemplate
    category_ids
    color
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateGoalSubscriptionVariables,
  APITypes.OnCreateGoalSubscription
>;
export const onUpdateGoal = /* GraphQL */ `subscription OnUpdateGoal($owner: String) {
  onUpdateGoal(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    start
    end
    allDay
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    todo
    notes
    complete
    recurrenceCompletionStates
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    completions
    completions_per_period
    period
    reference_code
    readGroups
    isTemplate
    category_ids
    color
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateGoalSubscriptionVariables,
  APITypes.OnUpdateGoalSubscription
>;
export const onDeleteGoal = /* GraphQL */ `subscription OnDeleteGoal($owner: String) {
  onDeleteGoal(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    start
    end
    allDay
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    todo
    notes
    complete
    recurrenceCompletionStates
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    completions
    completions_per_period
    period
    reference_code
    readGroups
    isTemplate
    category_ids
    color
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteGoalSubscriptionVariables,
  APITypes.OnDeleteGoalSubscription
>;
export const onCreateHabitat = /* GraphQL */ `subscription OnCreateHabitat {
  onCreateHabitat {
    id
    habitatID
    name
    favouriteRecipes {
      items {
        id
        habitatID
        recipeID
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    favouriteRecipeIDs
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateHabitatSubscriptionVariables,
  APITypes.OnCreateHabitatSubscription
>;
export const onUpdateHabitat = /* GraphQL */ `subscription OnUpdateHabitat {
  onUpdateHabitat {
    id
    habitatID
    name
    favouriteRecipes {
      items {
        id
        habitatID
        recipeID
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    favouriteRecipeIDs
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateHabitatSubscriptionVariables,
  APITypes.OnUpdateHabitatSubscription
>;
export const onDeleteHabitat = /* GraphQL */ `subscription OnDeleteHabitat {
  onDeleteHabitat {
    id
    habitatID
    name
    favouriteRecipes {
      items {
        id
        habitatID
        recipeID
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    favouriteRecipeIDs
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteHabitatSubscriptionVariables,
  APITypes.OnDeleteHabitatSubscription
>;
export const onCreateRecipeFavourite = /* GraphQL */ `subscription OnCreateRecipeFavourite {
  onCreateRecipeFavourite {
    id
    habitatID
    recipeID
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateRecipeFavouriteSubscriptionVariables,
  APITypes.OnCreateRecipeFavouriteSubscription
>;
export const onUpdateRecipeFavourite = /* GraphQL */ `subscription OnUpdateRecipeFavourite {
  onUpdateRecipeFavourite {
    id
    habitatID
    recipeID
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRecipeFavouriteSubscriptionVariables,
  APITypes.OnUpdateRecipeFavouriteSubscription
>;
export const onDeleteRecipeFavourite = /* GraphQL */ `subscription OnDeleteRecipeFavourite {
  onDeleteRecipeFavourite {
    id
    habitatID
    recipeID
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteRecipeFavouriteSubscriptionVariables,
  APITypes.OnDeleteRecipeFavouriteSubscription
>;
export const onCreateImage = /* GraphQL */ `subscription OnCreateImage {
  onCreateImage {
    id
    name
    habitatID
    readGroups
    data {
      bucket
      region
      key
      __typename
    }
    thumbnail {
      bucket
      region
      key
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateImageSubscriptionVariables,
  APITypes.OnCreateImageSubscription
>;
export const onUpdateImage = /* GraphQL */ `subscription OnUpdateImage {
  onUpdateImage {
    id
    name
    habitatID
    readGroups
    data {
      bucket
      region
      key
      __typename
    }
    thumbnail {
      bucket
      region
      key
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateImageSubscriptionVariables,
  APITypes.OnUpdateImageSubscription
>;
export const onDeleteImage = /* GraphQL */ `subscription OnDeleteImage {
  onDeleteImage {
    id
    name
    habitatID
    readGroups
    data {
      bucket
      region
      key
      __typename
    }
    thumbnail {
      bucket
      region
      key
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteImageSubscriptionVariables,
  APITypes.OnDeleteImageSubscription
>;
export const onCreateIngredientGroup = /* GraphQL */ `subscription OnCreateIngredientGroup {
  onCreateIngredientGroup {
    id
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateIngredientGroupSubscriptionVariables,
  APITypes.OnCreateIngredientGroupSubscription
>;
export const onUpdateIngredientGroup = /* GraphQL */ `subscription OnUpdateIngredientGroup {
  onUpdateIngredientGroup {
    id
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateIngredientGroupSubscriptionVariables,
  APITypes.OnUpdateIngredientGroupSubscription
>;
export const onDeleteIngredientGroup = /* GraphQL */ `subscription OnDeleteIngredientGroup {
  onDeleteIngredientGroup {
    id
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteIngredientGroupSubscriptionVariables,
  APITypes.OnDeleteIngredientGroupSubscription
>;
export const onCreateIngredientItem = /* GraphQL */ `subscription OnCreateIngredientItem {
  onCreateIngredientItem {
    id
    name
    groupID
    group {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    recipeGroupID
    recipeGroup {
      items {
        id
        recipeID
        display
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        ingredientID
        ingredient {
          items {
            id
            name
            groupID
            recipeGroupID
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        quantity
        unitOfMeasure
        pantryItem
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateIngredientItemSubscriptionVariables,
  APITypes.OnCreateIngredientItemSubscription
>;
export const onUpdateIngredientItem = /* GraphQL */ `subscription OnUpdateIngredientItem {
  onUpdateIngredientItem {
    id
    name
    groupID
    group {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    recipeGroupID
    recipeGroup {
      items {
        id
        recipeID
        display
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        ingredientID
        ingredient {
          items {
            id
            name
            groupID
            recipeGroupID
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        quantity
        unitOfMeasure
        pantryItem
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateIngredientItemSubscriptionVariables,
  APITypes.OnUpdateIngredientItemSubscription
>;
export const onDeleteIngredientItem = /* GraphQL */ `subscription OnDeleteIngredientItem {
  onDeleteIngredientItem {
    id
    name
    groupID
    group {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    recipeGroupID
    recipeGroup {
      items {
        id
        recipeID
        display
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        ingredientID
        ingredient {
          items {
            id
            name
            groupID
            recipeGroupID
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        quantity
        unitOfMeasure
        pantryItem
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteIngredientItemSubscriptionVariables,
  APITypes.OnDeleteIngredientItemSubscription
>;
export const onCreateLockPin = /* GraphQL */ `subscription OnCreateLockPin($owner: String!) {
  onCreateLockPin(owner: $owner) {
    user_id
    pin
    prompt_new_pin
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLockPinSubscriptionVariables,
  APITypes.OnCreateLockPinSubscription
>;
export const onUpdateLockPin = /* GraphQL */ `subscription OnUpdateLockPin($owner: String!) {
  onUpdateLockPin(owner: $owner) {
    user_id
    pin
    prompt_new_pin
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLockPinSubscriptionVariables,
  APITypes.OnUpdateLockPinSubscription
>;
export const onDeleteLockPin = /* GraphQL */ `subscription OnDeleteLockPin($owner: String!) {
  onDeleteLockPin(owner: $owner) {
    user_id
    pin
    prompt_new_pin
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLockPinSubscriptionVariables,
  APITypes.OnDeleteLockPinSubscription
>;
export const onCreateLogEvent = /* GraphQL */ `subscription OnCreateLogEvent {
  onCreateLogEvent {
    id
    type
    source
    platform
    user_id
    feature_domain
    data
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLogEventSubscriptionVariables,
  APITypes.OnCreateLogEventSubscription
>;
export const onUpdateLogEvent = /* GraphQL */ `subscription OnUpdateLogEvent {
  onUpdateLogEvent {
    id
    type
    source
    platform
    user_id
    feature_domain
    data
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLogEventSubscriptionVariables,
  APITypes.OnUpdateLogEventSubscription
>;
export const onDeleteLogEvent = /* GraphQL */ `subscription OnDeleteLogEvent {
  onDeleteLogEvent {
    id
    type
    source
    platform
    user_id
    feature_domain
    data
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLogEventSubscriptionVariables,
  APITypes.OnDeleteLogEventSubscription
>;
export const onCreateMealPlan = /* GraphQL */ `subscription OnCreateMealPlan {
  onCreateMealPlan {
    id
    habitatID
    week
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMealPlanSubscriptionVariables,
  APITypes.OnCreateMealPlanSubscription
>;
export const onUpdateMealPlan = /* GraphQL */ `subscription OnUpdateMealPlan {
  onUpdateMealPlan {
    id
    habitatID
    week
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMealPlanSubscriptionVariables,
  APITypes.OnUpdateMealPlanSubscription
>;
export const onDeleteMealPlan = /* GraphQL */ `subscription OnDeleteMealPlan {
  onDeleteMealPlan {
    id
    habitatID
    week
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteMealPlanSubscriptionVariables,
  APITypes.OnDeleteMealPlanSubscription
>;
export const onCreateOption = /* GraphQL */ `subscription OnCreateOption {
  onCreateOption {
    id
    type
    label
    code
    icon
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateOptionSubscriptionVariables,
  APITypes.OnCreateOptionSubscription
>;
export const onUpdateOption = /* GraphQL */ `subscription OnUpdateOption {
  onUpdateOption {
    id
    type
    label
    code
    icon
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateOptionSubscriptionVariables,
  APITypes.OnUpdateOptionSubscription
>;
export const onDeleteOption = /* GraphQL */ `subscription OnDeleteOption {
  onDeleteOption {
    id
    type
    label
    code
    icon
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteOptionSubscriptionVariables,
  APITypes.OnDeleteOptionSubscription
>;
export const onCreateRecordOption = /* GraphQL */ `subscription OnCreateRecordOption {
  onCreateRecordOption {
    id
    recordID
    optionID
    option {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateRecordOptionSubscriptionVariables,
  APITypes.OnCreateRecordOptionSubscription
>;
export const onUpdateRecordOption = /* GraphQL */ `subscription OnUpdateRecordOption {
  onUpdateRecordOption {
    id
    recordID
    optionID
    option {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRecordOptionSubscriptionVariables,
  APITypes.OnUpdateRecordOptionSubscription
>;
export const onDeleteRecordOption = /* GraphQL */ `subscription OnDeleteRecordOption {
  onDeleteRecordOption {
    id
    recordID
    optionID
    option {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteRecordOptionSubscriptionVariables,
  APITypes.OnDeleteRecordOptionSubscription
>;
export const onCreateProfile = /* GraphQL */ `subscription OnCreateProfile($owner: String!) {
  onCreateProfile(owner: $owner) {
    id
    habitatID
    userID
    name
    email
    role
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    stockImage
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProfileSubscriptionVariables,
  APITypes.OnCreateProfileSubscription
>;
export const onUpdateProfile = /* GraphQL */ `subscription OnUpdateProfile($owner: String!) {
  onUpdateProfile(owner: $owner) {
    id
    habitatID
    userID
    name
    email
    role
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    stockImage
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProfileSubscriptionVariables,
  APITypes.OnUpdateProfileSubscription
>;
export const onDeleteProfile = /* GraphQL */ `subscription OnDeleteProfile($owner: String!) {
  onDeleteProfile(owner: $owner) {
    id
    habitatID
    userID
    name
    email
    role
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    stockImage
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProfileSubscriptionVariables,
  APITypes.OnDeleteProfileSubscription
>;
export const onCreateRecipe = /* GraphQL */ `subscription OnCreateRecipe {
  onCreateRecipe {
    id
    habitatID
    readGroups
    name
    searchField
    emoji
    description
    imageUrl
    inProgress
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    mealTypes
    dishTypeID
    dishType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    dishTypeIDs
    skillLevelID
    skillLevel {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    servingSizeID
    servingSize {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    cuisineTypeID
    cuisineType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    familyfriendlyTypeID
    familyfriendlyType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    textureTypeID
    textureType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    specialDietIDs
    specialDiets {
      items {
        id
        recordID
        optionID
        option {
          id
          type
          label
          code
          icon
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    prepTimeID
    prepTime {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    prepNotes {
      id
      title
      icon
      description
      __typename
    }
    mainIngredientID
    mainIngredient {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    health
    budget
    utensils
    ingredients {
      id
      name
      quantity
      unitOfMeasure
      category
      pantryItem
      ingredientID
      __typename
    }
    recipeIngredients {
      items {
        id
        recipeID
        display
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        ingredientID
        ingredient {
          items {
            id
            name
            groupID
            recipeGroupID
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        quantity
        unitOfMeasure
        pantryItem
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    allergyIDs
    default_servings
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateRecipeSubscriptionVariables,
  APITypes.OnCreateRecipeSubscription
>;
export const onUpdateRecipe = /* GraphQL */ `subscription OnUpdateRecipe {
  onUpdateRecipe {
    id
    habitatID
    readGroups
    name
    searchField
    emoji
    description
    imageUrl
    inProgress
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    mealTypes
    dishTypeID
    dishType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    dishTypeIDs
    skillLevelID
    skillLevel {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    servingSizeID
    servingSize {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    cuisineTypeID
    cuisineType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    familyfriendlyTypeID
    familyfriendlyType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    textureTypeID
    textureType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    specialDietIDs
    specialDiets {
      items {
        id
        recordID
        optionID
        option {
          id
          type
          label
          code
          icon
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    prepTimeID
    prepTime {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    prepNotes {
      id
      title
      icon
      description
      __typename
    }
    mainIngredientID
    mainIngredient {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    health
    budget
    utensils
    ingredients {
      id
      name
      quantity
      unitOfMeasure
      category
      pantryItem
      ingredientID
      __typename
    }
    recipeIngredients {
      items {
        id
        recipeID
        display
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        ingredientID
        ingredient {
          items {
            id
            name
            groupID
            recipeGroupID
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        quantity
        unitOfMeasure
        pantryItem
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    allergyIDs
    default_servings
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRecipeSubscriptionVariables,
  APITypes.OnUpdateRecipeSubscription
>;
export const onDeleteRecipe = /* GraphQL */ `subscription OnDeleteRecipe {
  onDeleteRecipe {
    id
    habitatID
    readGroups
    name
    searchField
    emoji
    description
    imageUrl
    inProgress
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    mealTypes
    dishTypeID
    dishType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    dishTypeIDs
    skillLevelID
    skillLevel {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    servingSizeID
    servingSize {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    cuisineTypeID
    cuisineType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    familyfriendlyTypeID
    familyfriendlyType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    textureTypeID
    textureType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    specialDietIDs
    specialDiets {
      items {
        id
        recordID
        optionID
        option {
          id
          type
          label
          code
          icon
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    prepTimeID
    prepTime {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    prepNotes {
      id
      title
      icon
      description
      __typename
    }
    mainIngredientID
    mainIngredient {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    health
    budget
    utensils
    ingredients {
      id
      name
      quantity
      unitOfMeasure
      category
      pantryItem
      ingredientID
      __typename
    }
    recipeIngredients {
      items {
        id
        recipeID
        display
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        ingredientID
        ingredient {
          items {
            id
            name
            groupID
            recipeGroupID
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        quantity
        unitOfMeasure
        pantryItem
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    allergyIDs
    default_servings
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteRecipeSubscriptionVariables,
  APITypes.OnDeleteRecipeSubscription
>;
export const onCreateRecipeIngredientsGroup = /* GraphQL */ `subscription OnCreateRecipeIngredientsGroup {
  onCreateRecipeIngredientsGroup {
    id
    recipeID
    display
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    ingredientID
    ingredient {
      items {
        id
        name
        groupID
        group {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        recipeGroupID
        recipeGroup {
          items {
            id
            recipeID
            display
            ingredientID
            quantity
            unitOfMeasure
            pantryItem
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    quantity
    unitOfMeasure
    pantryItem
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateRecipeIngredientsGroupSubscriptionVariables,
  APITypes.OnCreateRecipeIngredientsGroupSubscription
>;
export const onUpdateRecipeIngredientsGroup = /* GraphQL */ `subscription OnUpdateRecipeIngredientsGroup {
  onUpdateRecipeIngredientsGroup {
    id
    recipeID
    display
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    ingredientID
    ingredient {
      items {
        id
        name
        groupID
        group {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        recipeGroupID
        recipeGroup {
          items {
            id
            recipeID
            display
            ingredientID
            quantity
            unitOfMeasure
            pantryItem
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    quantity
    unitOfMeasure
    pantryItem
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRecipeIngredientsGroupSubscriptionVariables,
  APITypes.OnUpdateRecipeIngredientsGroupSubscription
>;
export const onDeleteRecipeIngredientsGroup = /* GraphQL */ `subscription OnDeleteRecipeIngredientsGroup {
  onDeleteRecipeIngredientsGroup {
    id
    recipeID
    display
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    ingredientID
    ingredient {
      items {
        id
        name
        groupID
        group {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        recipeGroupID
        recipeGroup {
          items {
            id
            recipeID
            display
            ingredientID
            quantity
            unitOfMeasure
            pantryItem
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    quantity
    unitOfMeasure
    pantryItem
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteRecipeIngredientsGroupSubscriptionVariables,
  APITypes.OnDeleteRecipeIngredientsGroupSubscription
>;
export const onCreateScheduledMessage = /* GraphQL */ `subscription OnCreateScheduledMessage {
  onCreateScheduledMessage {
    id
    dialogTrigger
    rrule
    periodOffset
    scheduledDate
    scheduledTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateScheduledMessageSubscriptionVariables,
  APITypes.OnCreateScheduledMessageSubscription
>;
export const onUpdateScheduledMessage = /* GraphQL */ `subscription OnUpdateScheduledMessage {
  onUpdateScheduledMessage {
    id
    dialogTrigger
    rrule
    periodOffset
    scheduledDate
    scheduledTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateScheduledMessageSubscriptionVariables,
  APITypes.OnUpdateScheduledMessageSubscription
>;
export const onDeleteScheduledMessage = /* GraphQL */ `subscription OnDeleteScheduledMessage {
  onDeleteScheduledMessage {
    id
    dialogTrigger
    rrule
    periodOffset
    scheduledDate
    scheduledTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteScheduledMessageSubscriptionVariables,
  APITypes.OnDeleteScheduledMessageSubscription
>;
export const onCreateStickyNote = /* GraphQL */ `subscription OnCreateStickyNote {
  onCreateStickyNote {
    id
    habitatID
    content
    color
    ownerID
    owner {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    sharedWithIDs
    acknowledgements {
      user_id
      date
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateStickyNoteSubscriptionVariables,
  APITypes.OnCreateStickyNoteSubscription
>;
export const onUpdateStickyNote = /* GraphQL */ `subscription OnUpdateStickyNote {
  onUpdateStickyNote {
    id
    habitatID
    content
    color
    ownerID
    owner {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    sharedWithIDs
    acknowledgements {
      user_id
      date
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateStickyNoteSubscriptionVariables,
  APITypes.OnUpdateStickyNoteSubscription
>;
export const onDeleteStickyNote = /* GraphQL */ `subscription OnDeleteStickyNote {
  onDeleteStickyNote {
    id
    habitatID
    content
    color
    ownerID
    owner {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    sharedWithIDs
    acknowledgements {
      user_id
      date
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteStickyNoteSubscriptionVariables,
  APITypes.OnDeleteStickyNoteSubscription
>;
export const onCreateSystemProperty = /* GraphQL */ `subscription OnCreateSystemProperty {
  onCreateSystemProperty {
    name
    label
    description
    value
    read_groups
    public
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateSystemPropertySubscriptionVariables,
  APITypes.OnCreateSystemPropertySubscription
>;
export const onUpdateSystemProperty = /* GraphQL */ `subscription OnUpdateSystemProperty {
  onUpdateSystemProperty {
    name
    label
    description
    value
    read_groups
    public
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateSystemPropertySubscriptionVariables,
  APITypes.OnUpdateSystemPropertySubscription
>;
export const onDeleteSystemProperty = /* GraphQL */ `subscription OnDeleteSystemProperty {
  onDeleteSystemProperty {
    name
    label
    description
    value
    read_groups
    public
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteSystemPropertySubscriptionVariables,
  APITypes.OnDeleteSystemPropertySubscription
>;
export const onCreateTaskList = /* GraphQL */ `subscription OnCreateTaskList($owner: String) {
  onCreateTaskList(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    primaryIngredientList
    top
    favourite
    isAkinList
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    image
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateTaskListSubscriptionVariables,
  APITypes.OnCreateTaskListSubscription
>;
export const onUpdateTaskList = /* GraphQL */ `subscription OnUpdateTaskList($owner: String) {
  onUpdateTaskList(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    primaryIngredientList
    top
    favourite
    isAkinList
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    image
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateTaskListSubscriptionVariables,
  APITypes.OnUpdateTaskListSubscription
>;
export const onDeleteTaskList = /* GraphQL */ `subscription OnDeleteTaskList($owner: String) {
  onDeleteTaskList(owner: $owner) {
    id
    habitatID
    emoji
    title
    type
    primaryIngredientList
    top
    favourite
    isAkinList
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    image
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteTaskListSubscriptionVariables,
  APITypes.OnDeleteTaskListSubscription
>;
export const onCreateUser = /* GraphQL */ `subscription OnCreateUser {
  onCreateUser {
    id
    sub
    name
    location
    username
    primary
    habitatID
    role
    email
    phoneNumber
    NDISAccountName
    NDISNumber
    birthday
    planManagerName
    planManagerEmail
    emailVerified
    carerPhone
    carerName
    supportWorkerPhone
    supportWorkerName
    contacts
    favouriteContacts
    address {
      type
      street
      city
      state
      postcode
      country
      __typename
    }
    profileColor
    profilePicture
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    customPictureURL
    systemPreferences {
      androidNotificationSoundID
      androidAlarmSoundID
      __typename
    }
    scheduledMessages {
      items {
        id
        userID
        habitatID
        scheduledMessageID
        scheduledMessage {
          id
          dialogTrigger
          rrule
          periodOffset
          scheduledDate
          scheduledTime
          createdAt
          updatedAt
          __typename
        }
        scheduledDate
        scheduledTime
        answered
        delayCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    endpointIds
    hasCompletedMealOnboarding
    hasViewedMealSection
    hasViewedGoalSection
    recipePreferenceOptionIDs
    onboardingToken
    hasOnboarded
    skippedOnboardingWizard
    onboardingRecipeChoices
    dashboardLayoutPreset
    chatApplicationId
    people
    budget
    time_and_effort
    dietary_balance
    allergies
    prepTime
    avoidances {
      category
      degree
      __typename
    }
    skillLevel
    is_child_profile
    use_generative_ai {
      name
      model
      max_tokens
      temperature
      __typename
    }
    favourite_recipe_ids
    contact_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserSubscriptionVariables,
  APITypes.OnCreateUserSubscription
>;
export const onUpdateUser = /* GraphQL */ `subscription OnUpdateUser {
  onUpdateUser {
    id
    sub
    name
    location
    username
    primary
    habitatID
    role
    email
    phoneNumber
    NDISAccountName
    NDISNumber
    birthday
    planManagerName
    planManagerEmail
    emailVerified
    carerPhone
    carerName
    supportWorkerPhone
    supportWorkerName
    contacts
    favouriteContacts
    address {
      type
      street
      city
      state
      postcode
      country
      __typename
    }
    profileColor
    profilePicture
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    customPictureURL
    systemPreferences {
      androidNotificationSoundID
      androidAlarmSoundID
      __typename
    }
    scheduledMessages {
      items {
        id
        userID
        habitatID
        scheduledMessageID
        scheduledMessage {
          id
          dialogTrigger
          rrule
          periodOffset
          scheduledDate
          scheduledTime
          createdAt
          updatedAt
          __typename
        }
        scheduledDate
        scheduledTime
        answered
        delayCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    endpointIds
    hasCompletedMealOnboarding
    hasViewedMealSection
    hasViewedGoalSection
    recipePreferenceOptionIDs
    onboardingToken
    hasOnboarded
    skippedOnboardingWizard
    onboardingRecipeChoices
    dashboardLayoutPreset
    chatApplicationId
    people
    budget
    time_and_effort
    dietary_balance
    allergies
    prepTime
    avoidances {
      category
      degree
      __typename
    }
    skillLevel
    is_child_profile
    use_generative_ai {
      name
      model
      max_tokens
      temperature
      __typename
    }
    favourite_recipe_ids
    contact_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserSubscriptionVariables,
  APITypes.OnUpdateUserSubscription
>;
export const onDeleteUser = /* GraphQL */ `subscription OnDeleteUser {
  onDeleteUser {
    id
    sub
    name
    location
    username
    primary
    habitatID
    role
    email
    phoneNumber
    NDISAccountName
    NDISNumber
    birthday
    planManagerName
    planManagerEmail
    emailVerified
    carerPhone
    carerName
    supportWorkerPhone
    supportWorkerName
    contacts
    favouriteContacts
    address {
      type
      street
      city
      state
      postcode
      country
      __typename
    }
    profileColor
    profilePicture
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    customPictureURL
    systemPreferences {
      androidNotificationSoundID
      androidAlarmSoundID
      __typename
    }
    scheduledMessages {
      items {
        id
        userID
        habitatID
        scheduledMessageID
        scheduledMessage {
          id
          dialogTrigger
          rrule
          periodOffset
          scheduledDate
          scheduledTime
          createdAt
          updatedAt
          __typename
        }
        scheduledDate
        scheduledTime
        answered
        delayCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    endpointIds
    hasCompletedMealOnboarding
    hasViewedMealSection
    hasViewedGoalSection
    recipePreferenceOptionIDs
    onboardingToken
    hasOnboarded
    skippedOnboardingWizard
    onboardingRecipeChoices
    dashboardLayoutPreset
    chatApplicationId
    people
    budget
    time_and_effort
    dietary_balance
    allergies
    prepTime
    avoidances {
      category
      degree
      __typename
    }
    skillLevel
    is_child_profile
    use_generative_ai {
      name
      model
      max_tokens
      temperature
      __typename
    }
    favourite_recipe_ids
    contact_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserSubscriptionVariables,
  APITypes.OnDeleteUserSubscription
>;
export const onCreateContact = /* GraphQL */ `subscription OnCreateContact {
  onCreateContact {
    id
    habitatID
    name
    type
    tags
    phoneNumbers {
      number
      type
      __typename
    }
    emailAddresses
    addresses {
      type
      street
      city
      state
      postcode
      country
      __typename
    }
    notes
    contactColor
    stockImage
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    publicImageURL
    user_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateContactSubscriptionVariables,
  APITypes.OnCreateContactSubscription
>;
export const onUpdateContact = /* GraphQL */ `subscription OnUpdateContact {
  onUpdateContact {
    id
    habitatID
    name
    type
    tags
    phoneNumbers {
      number
      type
      __typename
    }
    emailAddresses
    addresses {
      type
      street
      city
      state
      postcode
      country
      __typename
    }
    notes
    contactColor
    stockImage
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    publicImageURL
    user_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateContactSubscriptionVariables,
  APITypes.OnUpdateContactSubscription
>;
export const onDeleteContact = /* GraphQL */ `subscription OnDeleteContact {
  onDeleteContact {
    id
    habitatID
    name
    type
    tags
    phoneNumbers {
      number
      type
      __typename
    }
    emailAddresses
    addresses {
      type
      street
      city
      state
      postcode
      country
      __typename
    }
    notes
    contactColor
    stockImage
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    publicImageURL
    user_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteContactSubscriptionVariables,
  APITypes.OnDeleteContactSubscription
>;
export const onCreateUserScheduledMessage = /* GraphQL */ `subscription OnCreateUserScheduledMessage {
  onCreateUserScheduledMessage {
    id
    userID
    habitatID
    scheduledMessageID
    scheduledMessage {
      id
      dialogTrigger
      rrule
      periodOffset
      scheduledDate
      scheduledTime
      createdAt
      updatedAt
      __typename
    }
    scheduledDate
    scheduledTime
    answered
    delayCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserScheduledMessageSubscriptionVariables,
  APITypes.OnCreateUserScheduledMessageSubscription
>;
export const onUpdateUserScheduledMessage = /* GraphQL */ `subscription OnUpdateUserScheduledMessage {
  onUpdateUserScheduledMessage {
    id
    userID
    habitatID
    scheduledMessageID
    scheduledMessage {
      id
      dialogTrigger
      rrule
      periodOffset
      scheduledDate
      scheduledTime
      createdAt
      updatedAt
      __typename
    }
    scheduledDate
    scheduledTime
    answered
    delayCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserScheduledMessageSubscriptionVariables,
  APITypes.OnUpdateUserScheduledMessageSubscription
>;
export const onDeleteUserScheduledMessage = /* GraphQL */ `subscription OnDeleteUserScheduledMessage {
  onDeleteUserScheduledMessage {
    id
    userID
    habitatID
    scheduledMessageID
    scheduledMessage {
      id
      dialogTrigger
      rrule
      periodOffset
      scheduledDate
      scheduledTime
      createdAt
      updatedAt
      __typename
    }
    scheduledDate
    scheduledTime
    answered
    delayCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserScheduledMessageSubscriptionVariables,
  APITypes.OnDeleteUserScheduledMessageSubscription
>;
